import React, { useCallback, useEffect, useState } from "react";

interface TabsProps {
  allTabRefs: any;
  currentTab: string;
}

function ActiveTabIndicator({ allTabRefs, currentTab }: TabsProps) {
  const [underlineWidth, setUnderlineWidth] = useState(0);
  const [underlineOffset, setUnderlineOffset] = useState(0);

  const updateUnderlinePosition = useCallback(() => {
    setTimeout(() => {
      if (allTabRefs.current[currentTab]) {
        setUnderlineWidth(allTabRefs.current[currentTab].offsetWidth);
        setUnderlineOffset(allTabRefs.current[currentTab].offsetLeft);

        allTabRefs.current[currentTab].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }, 100);
  }, [allTabRefs, currentTab]);

  useEffect(() => {
    updateUnderlinePosition();
    window.addEventListener("resize", updateUnderlinePosition);

    return () => {
      window.removeEventListener("resize", updateUnderlinePosition);
    };
  }, [currentTab, updateUnderlinePosition]);

  return (
    <span
      className="absolute bottom-0 h-0.5 bg-black transition-all duration-300 rounded-md -mb-[1px]"
      style={{
        width: `${underlineWidth}px`,
        left: `${underlineOffset}px`,
      }}
    />
  );
}

export default ActiveTabIndicator;
